import { createContext } from 'react';
import { Folder, FolderAbilities, FolderPayload, FoldersListSorting } from '../types';

export type FoldersContextBaseProps = {
  rootFolder: Folder;
  folderAbilities: FolderAbilities;
  createFolder: (folderPayload: FolderPayload) => Promise<string>;
  onFoldersSortingChange?: (foldersSorting: FoldersListSorting) => void;
};

export type FoldersContextProps = FoldersContextBaseProps & {
  isCreateFolderDialogOpen: boolean;
  isMoveFolderDialogOpen: boolean;
  isDuplicateFolderDialogOpen: boolean;
  isRenameFolderDialogOpen: boolean;
  isDeleteFolderDialogOpen: boolean;
  activeFolder: Folder;
  foldersMap: Map<string, Folder>;
  foldersSorting: FoldersListSorting;
  setActiveFolder: (folder: Folder) => void;
  setIsCreateFolderDialogOpen: (isOpen: boolean) => void;
  setIsMoveFolderDialogOpen: (isOpen: boolean) => void;
  setIsDuplicateFolderDialogOpen: (isOpen: boolean) => void;
  setIsRenameFolderDialogOpen: (isOpen: boolean) => void;
  setIsDeleteFolderDialogOpen: (isOpen: boolean) => void;
};

export const FoldersContext = createContext<FoldersContextProps | undefined>(undefined);
